import { Card, Modal } from 'corso-admin-ui';
import ClipboardButton from '~/components/ClipboardButton';
import { useShippingClaim } from '../ShippingClaimReviewProvider';

export function StoreEmailContacts({
  show,
  onClose,
}: {
  show: boolean;
  onClose: () => void;
}) {
  const { storeContacts } = useShippingClaim();

  return (
    <Modal onClose={onClose} show={show} title="Store Contacts">
      {storeContacts.length ? (
        storeContacts.map(({ email, name }) => (
          <Card.Line key={email}>
            <div className="flex flex-col gap-1">
              <p className="text-xs font-semibold text-neutral-500">{name}</p>
              <p className="text-xs text-neutral-500">{email}</p>
            </div>
            <ClipboardButton
              variant="ghost"
              accessibilityLabel={`Copy ${email}`}
              onClick={() => email}
            />
          </Card.Line>
        ))
      ) : (
        <p className="text-xs text-neutral-500">No store contacts</p>
      )}
    </Modal>
  );
}
